import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ticket-alt" }, null, -1)

import { ref, watch } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  status?: "" | "error" | "warning";
  maxLength?: number;
  uppercase?: boolean;
  showApply?: boolean;
  applyText?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CouponCodeInput',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "Nhập mã giảm giá" },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    status: { default: "" },
    maxLength: { default: 30 },
    uppercase: { type: Boolean, default: true },
    showApply: { type: Boolean, default: true },
    applyText: { default: "Áp dụng" }
  },
  emits: ["update:modelValue", "change", "apply", "blur", "pressEnter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const displayValue = ref("");

const normalize = (value: string) => {
  let next = value.replace(/[^a-zA-Z0-9\-_]/g, "");
  if (props.uppercase) next = next.toUpperCase();
  return next.slice(0, props.maxLength);
};

watch(
  () => props.modelValue,
  (val) => {
    displayValue.value = normalize(val ?? "");
  },
  { immediate: true }
);

const onInput = (val: string) => {
  const next = normalize(val);
  displayValue.value = next;
  emit("update:modelValue", next);
  emit("change", next);
};

const onApply = () => {
  if (!displayValue.value) return;
  emit("apply", displayValue.value);
};

const onBlur = (e: FocusEvent) => emit("blur", e);

const onPressEnter = (e: KeyboardEvent) => {
  emit("pressEnter", e);
  onApply();
};

return (_ctx: any,_cache: any) => {
  const _component_h_button = _resolveComponent("h-button")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createBlock(_component_a_input, {
    value: displayValue.value,
    "onUpdate:value": [
      _cache[0] || (_cache[0] = ($event: any) => ((displayValue).value = $event)),
      onInput
    ],
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    maxlength: _ctx.maxLength,
    status: _ctx.status,
    class: "ant-coupon-code-input",
    onBlur: onBlur,
    onPressEnter: onPressEnter
  }, _createSlots({
    prefix: _withCtx(() => [
      _hoisted_1
    ]),
    _: 2
  }, [
    (_ctx.showApply)
      ? {
          name: "suffix",
          fn: _withCtx(() => [
            _createVNode(_component_h_button, {
              type: "link",
              size: "small",
              disabled: !displayValue.value || _ctx.disabled,
              onClick: onApply
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.applyText), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["value", "placeholder", "disabled", "size", "allow-clear", "maxlength", "status"]))
}
}

})